import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-42fb3300")

_pushScopeId("data-v-42fb3300")
const _hoisted_1 = { class: "free-area" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_radio_button = _resolveComponent("radio-button")

  return (_openBlock(), _createBlock("div", {
    class: "radio-button-card-frame",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click', $event)))
  }, [
    _createVNode(_component_radio_button, { checked: _ctx.selected }, null, 8, ["checked"]),
    _createVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
})